import React, { Context as ReactContext } from 'react';
import { Context } from './types';

const ModalContext: ReactContext<Context> = React.createContext<Context>({
  modalContentRootRef: null,
});

export default ModalContext;
